import * as types from '../types';

const state = {
  tableLoading: false,
};

const mutations = {
    [types.TABLELOADING] (state, status) {
        state.tableLoading = status;
    },
};

const getters = {};

const actions = {};
export default {
    state,
    actions,
    getters,
    mutations
};
